<template>
  <div class="c++">
    <evaluation-content-model :id="3"></evaluation-content-model>
  </div>
</template>

<script>
import EvaluationContentModel from './components/EvaluationContentModel.vue'
export default {
  components: { EvaluationContentModel },
}
</script>

<style>

</style>